import Countdown from '@/components/countdown'

let $vm
const countdownPlugin = (Vue, options) => {
  const CD = Vue.extend(Countdown)

  const countdownFn = {
    init(startTimeStamp, endTimeStamp) {
      if (!$vm) {
        $vm = new CD({
          el: document.createElement('div')
        })
        document.body.appendChild($vm.$el)
      }
      $vm.startTimeStamp = startTimeStamp
      $vm.endTimeStamp = endTimeStamp
    },
    get current() {
      return ($vm && $vm.countDown) || ['00', '00', '00', '00']
    }
  }
  Vue.prototype.$countdown = countdownFn
}

export default countdownPlugin